import { rootApi } from "../../api/rootApi";

export const ActiveUsersApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getActiveUsers: builder.mutation({
      query: (params) => {
        console.log("body ......................", params);
        return {
          method: "POST",
          url: "/tenant/getActiveUsers",
          headers: {
            "Content-Type": "application/json",
            slug: `${params.tenant_id}`,
            Authorization: "Bearer " + params.token,
          },
          body : JSON.stringify(params.body)
        };
      },
    }),
  }),
});

export const {
    useGetActiveUsersMutation
} = ActiveUsersApi;


export const SessionMetricsApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getSessionMetrics: builder.mutation({
      query: (params) => {
        const q = new URLSearchParams();
        if (params.user_id) q.append("user_id", params.user_id);
        if (params.mobile) q.append("mobile", params.mobile);
        if (params.from_date) q.append("from_date", params.from_date);
        if (params.to_date) q.append("to_date", params.to_date);
        if (params.page) q.append("page", params.page);
        if (params.limit) q.append("limit", params.limit);
        return {
          method: "GET",
          url: `/app/activity/app-sessions/metrics?${q.toString()}`,
          headers: {
            "Content-Type": "application/json",
            slug: `${params.tenant_id}`,
            Authorization: "Bearer " + params.token,
          },
        };
      },
    }),
    getUserSessionDetail: builder.mutation({
      query: (params) => ({
        method: "GET",
        url: `/app/activity/app-sessions/user-detail?app_user_id=${params.app_user_id}`,
        headers: {
          "Content-Type": "application/json",
          slug: `${params.tenant_id}`,
          Authorization: "Bearer " + params.token,
        },
      }),
    }),

    exportAppSessions: builder.mutation({
      query: (params) => {
        const q = new URLSearchParams();
        if (params.user_id) q.append("user_id", params.user_id);
        if (params.start_date) q.append("start_date", params.start_date);
        if (params.end_date) q.append("end_date", params.end_date);
        return {
          method: "GET",
          url: `/app/activity/app-sessions/export-sessions-report?${q.toString()}`,
          headers: {
            "Content-Type": "application/json",
            slug: `${params.tenant_id}`,
            Authorization: "Bearer " + params.token,
          },
        };
      },
    }),
  }),
});

export const { useGetSessionMetricsMutation, useGetUserSessionDetailMutation,useExportAppSessionsMutation } = SessionMetricsApi;
